interface Props {
  status: string;
}

/**
 * Colour-coded pill for sync_runs / backfill statuses.
 * Maps the backend's string states onto tailwind `badge-*` classes.
 */
export function StatusBadge({ status }: Props) {
  const cls =
    status === "success" || status === "done"
      ? "badge-success"
      : status === "running"
        ? "badge-running"
        : status === "error"
          ? "badge-error"
          : status === "pending"
            ? "badge-pending"
            : "badge-neutral";
  return <span className={cls}>{status}</span>;
}
